<template>
  <div>
    
    <v-layout column align-center>

      <v-layout 
      v-if="isLoading"
      row justify-center align-center shrink>
        <v-icon 
        class="rotate-infinite">
        sync
        </v-icon>
      </v-layout>

      <div class="subheading">{{ (item.definition || {}).name }}</div>

      <img src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="80px">

      <div class="display-1">
        <c-ms-ii
        :key="item.id + 'a'"
        :prefferedSid="prefferedSid"
        :metric_definition="item.definition"
        :realValue="initialValue"
        labelMode
        alwaysScale>
        </c-ms-ii>
      </div>
        
    </v-layout>

     <v-layout align-center class="mt-4 subheading">
        <v-icon color="text" small>mdi-barcode</v-icon>
        &nbsp;
        {{ item.batch_number || 'Batch number not set'}}
      </v-layout>

      <v-layout align-center class="mb-4 subheading">
        <v-icon color="text" small>mdi-qrcode-scan</v-icon>
        &nbsp;
        {{ item.archive_id }}
      </v-layout>

    <div>

      <v-layout align-center class="label mt-4">
        Modification&nbsp;
        <v-layout align-center :class="modIsAddition ? 'green--text' : 'red--text'" style="display: inline-flex;">
          (
        <v-icon :color="modIsAddition ? 'green' : 'red'">{{ modIsAddition ? 'mdi-plus' : 'mdi-minus'}}</v-icon>
        {{ modIsAddition ? 'Add' : 'Subtract' }}
          )
        </v-layout>
      </v-layout>


      <c-ms-ii
      :class="['display-1 crx-box-input', {'green--text': modIsAddition}, {'red--text': !modIsAddition}]"
      style="max-width: 400px;"
      :key="item.id + 'b'"
      :prefferedSid="prefferedSid"
      :metric_definition="item.definition"
      :realValue.sync="modValue"
      :focussed.sync="modFocussed">
      </c-ms-ii>

      <div class="label mt-4">
        New Quantity
      </div>

      <c-ms-ii
      style="max-width: 400px;"
      :key="item.id + 'c'"
      :prefferedSid="prefferedSid"
      :metric_definition="item.definition"
      class="display-1 crx-box-input"
      :realValue.sync="realValue">
      </c-ms-ii>

    </div>

    <v-layout pt-2 pb-2>
      <v-spacer></v-spacer>
        <v-btn
        color="textSecondary"
        text @click="$emit('onClose')">
          CANCEL
        </v-btn>
        <v-btn 
        text
        @click="updateItem"
        :loading="loading" 
        color="primary" 
        >
          {{ realValue === 0 ? 'DELETE' : 'UPDATE' }}
        </v-btn>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: ['invID'],
  data () {
    return {
      loading: false,
      isLoading: false,
      initialValue: 0,
      realValue: 0,
      modValue: 0,
      modFocussed: false,
      prefferedSid: null,
      item: {
        definition: null
      }
    }
  },
  computed: {
    modIsAddition () {
      return this.modValue >= 0
    }
  },
  watch: {
    modValue (nv) {
      this.recalculateRealValue()
    },
    realValue (nv) {
      if (!this.modFocussed) {
        this.modValue = nv - this.initialValue
      }
    }
  },
  methods: {
    recalculateRealValue () {
      this.realValue = this.initialValue + this.modValue
    },
    updateItem () {
      this.loading = true
      this.$axios.patch('inventory/update/',
        {
          id: this.item.id,
          quantity: this.realValue
        },
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            this.$emit('onUpdate')
            this.$emit('onClose')
          })
        .catch(error => this.$root.$errorSnackbar(error))
        .then(() => {
          this.loading = false
        })
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        this.$axios.get(`/inventory/item/${this.invID}`)
          .then(response => {
            var hrend = response.data.execution_time
            // console.log(hrend)
            // console.info('Execution time (hr): %ds %dms', hrend[0], hrend[1] / 1000000)
            this.item = response.data.row
            console.log('RECEIVED')
            console.log(this.item)
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true})
  },
  mounted () {
    this.loadAPI()
      .then(() => {
        this.initialValue = this.item.quantity
        this.realValue = this.item.quantity
        var hmetric = this.$crx.metrics.humanizeDBMetric(this.realValue, this.item.definition.metric)
        this.prefferedSid = hmetric.sid
      })
  }
}
</script>

<style>

</style>

